import axios from "axios";
import ApiCall from "../constants/Api";

export const helpAxios = async (svc, endpoint, options, session) => {
  if (endpoint === ApiCall.PING || endpoint === ApiCall.PING_LEGACY) {
    return axios
      .get(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return { error: err };
      });
  }

  // Axios with Proxy Login and Logout
  if (
    endpoint === ApiCall.LOGIN ||
    endpoint === ApiCall.LOGOUT ||
    endpoint === ApiCall.GET_MY_IP ||
    endpoint === ApiCall.ONLINE_RESET_USER_PASSWORD ||
    endpoint === ApiCall.INVOKE_GET_METHOD
  ) {
    return axios
      .post(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, options, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.data.OutParams.Result !== 0) {
            return {
              error: response.data.OutParams.ErrMsg,
              errorCode: response.data.OutParams.Result,
              data: response.data,
            };
          } else {
            return response.data;
          }
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  } else {
    // Axios with Proxy All methods
    let request = {
      ServiceName: svc,
      MethodName: endpoint,
      Json: options,
    };
    return axios
      .post(
        window.config.SiteConfig.PROXYSEC_SVC + "/" + ApiCall.INVOKEMETHOD,
        request,
        {
          headers: {
            "X-SESSIONID": session,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.OutParams.Result !== 0) {
            return {
              error: response.data.OutParams.ErrMsg,
              Result: response.data.OutParams.Result,
            };
          } else {
            const result =
              response.data.Json?.Result ??
              response.data.Json?.OutParams?.Result;
            const errMsg =
              response.data.Json?.ErrMsg ??
              response.data.Json?.OutParams?.ErrMsg;
            if (result !== 0) {
              return {
                error: errMsg,
                Result: result,
              };
            } else {
              return response.data.Json;
            }
          }
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  }
};
